// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '신일제약',
  targetSheetName: '신일제약 CSO 제품별 수수료율',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '품목명',
    price: '보험약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '번호',
    '효능군',
    '품목명',
    '성분',
    '보험약가',
    '수수료율',
    '보험코드',
    '포장규격',
    '생산방식/생동',
    '대조약',
    '비고',
  ],
});
